import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  get<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    return this.isJSONValid(item) ? (JSON.parse(item) as T) : (item as unknown as T);
  }
  
  set(key: string, value: unknown): void {
    return localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
  
  private isJSONValid(value: string): boolean {
    return JSON.parse(value) ? true : false;
    // try {
    //   JSON.parse(value);
    //   return true;
    // } catch (error) {
    //   return false;
    // }
  }

}